import React from 'react';
import '../App.css';

/**
 * Shared footer displayed on all pages.
 * NOTE: A duplicate footer exists in CustomInstallPageRenderer.java for the
 * server-rendered Bolt install page. Keep both in sync when making changes.
 */
function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 2026 Winston. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
